import {wordByCount} from '../../../../components/utils';
import {rechargeLabel} from '../model/labels';
import type {FormulaValue, Recharge} from '../model/types';

export const byTitle = (first: string, second: string) => first.localeCompare(second, 'ru');

export const formatBonus = (value: number) => (value >= 0 ? `+${value}` : `−${-value}`);

const FEET_WORDS = ['фут', 'фута', 'футов'];

/** «30 футов»: футы не сокращаем */
export const formatFeet = (value: number) => wordByCount(value, FEET_WORDS, true);

/** дальность вида «80/320» с единицей по последнему числу: «80/320 футов» */
export const formatRange = (range: string) => {
	const last = Number(range.match(/\d+(?!.*\d)/)?.[0] || 0);
	return `${range} ${wordByCount(last, FEET_WORDS)}`;
};

export const formatPounds = (value: number) =>
	Number.isInteger(value)
		? wordByCount(value, ['фунт', 'фунта', 'фунтов'], true)
		: `${value.toLocaleString('ru')} фунта`;

export const formatFormula = (value: FormulaValue | undefined) => (value == null ? '' : String(value));

export function usageText(usage: FormulaValue | undefined, recharge: Recharge | undefined): string {
	const count = usage === 'at-will' ? 'неограниченно' : usage != null ? usageCount(usage) : '';
	const rechargeText = recharge ? `восстановление: ${rechargeLabel(recharge)}` : '';
	return [count, rechargeText].filter(Boolean).join(', ');
}

const usageCount = (usage: FormulaValue) =>
	typeof usage === 'number' ? wordByCount(usage, ['раз', 'раза', 'раз'], true) : `${usage} раз`;
